





































































































































import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
import FormGenerator from "@/components/FormGeneration.vue";
import parseISO from "date-fns/parseISO";
import isBefore from "date-fns/isBefore";
export default Vue.extend({
  name: "campaign-details",
  components: {
    FormGenerator
  },
  data() {
    return {
      loadDone: true,
      campaign: null,
      fields: null,
      saving: false,
      file: null,
      upLoading: false
    };
  },
  created() {
    // this.reload();
    if (!this.itemEdit) {
      this.$router.push({ name: "campaign" });
      return;
    }
    this.setCampaign(this.itemEdit);
  },
  computed: {
    ...mapGetters({
      itemEdit: "productCampaign/itemEdit"
    })
  },
  methods: {
    ...mapActions({
      importFarmerCampaign: "productCampaign/importFarmerCampaign"
    }),
    async upload() {
      this.upLoading = true;
      try {
        await this.importFarmerCampaign({
          productCampaignId: this.campaign._id,
          file: this.file
        });
        this.upLoading = false;
      } catch (error) {
        this.upLoading = false;
        console.log(error.message);
      }
    },
    testCampaign(id: string) {
      this.$router.push({ name: "campaignTest", params: { id: id } });
    },
    // async reload(local = true) {
    //   try {
    //     this.loadDone = false;
    //     let items = await this.$store.dispatch("campaign/getList", {
    //       local,
    //       query: {
    //         limit: 1,
    //         filter: { code: this.$route.params.id }
    //       }
    //     });
    //     if (items.length) {
    //       this.setCampaign(items[0]);
    //     } else {
    //       throw new Error("Không tìm thấy mã vòng quay");
    //     }
    //   } catch (err) {
    //     this.$store.dispatch(
    //       "error/handleError",
    //       err,
    //       "Lấy thông tin vòng quay thất bại"
    //     );
    //   } finally {
    //     this.loadDone = true;
    //   }
    // },
    formChanged(event) {
      this.campaign = { ...this.campaign, ...event };
    },
    setCampaign(campaign) {
      if (campaign["endDate"]) {
        this.campaign = {
          ...campaign,
          endDate: new Date(campaign["endDate"])
        };
      }
      if (campaign["startDate"]) {
        this.campaign = {
          ...campaign,
          startDate: new Date(campaign["startDate"])
        };
      }
      if (campaign["startDate"] && campaign["endDate"]) {
        this.campaign = {
          ...campaign,
          startDate: new Date(campaign["startDate"]),
          endDate: new Date(campaign["endDate"])
        };
      }
      if (!campaign["endDate"]) {
        this.campaign = {
          ...campaign,
          endDate: new Date()
        };
      }
      if (!campaign["startDate"]) {
        this.campaign = {
          ...campaign,
          startDate: new Date()
        };
      }

      this.fields = [
        {
          type: "text",
          label: "Mã vòng quay",
          property: "code",
          col: "is-4",
          readonly: true,
          required: true
        },
        {
          type: "text",
          label: "Tên vòng quay",
          inputType: "text",
          property: "title",
          col: "is-5",
          required: true
        },
        {
          type: "text",
          label: "Doanh số/ vòng quay",
          placeholder: "0",
          property: "spinPoint",
          inputType: "number",
          col: "is-3",
          required: true
        },
        {
          type: "date",
          label: "Ngày bắt đầu",
          property: "startDate",
          col: "is-3"
        },
        {
          type: "date",
          label: "Ngày hết hạn",
          property: "endDate",
          col: "is-3"
        },
        {
          type: "text",
          inputType: "number",
          label: "Giới hạn ngày",
          property: "limitDate",
          col: "is-3"
        },
        {
          type: "text",
          inputType: "number",
          label: "Giới hạn số lượng",
          property: "limitAmount",
          col: "is-3"
        },
        {
          type: "image",
          label: "Ảnh background",
          property: "backgroundImage",
          placeholder: "URL ảnh",
          col: "is-4"
        },
        {
          type: "image",
          label: "Ảnh banner",
          property: "bannerImage",
          placeholder: "URL ảnh",
          col: "is-4"
        },
        {
          type: "image",
          label: "Ảnh footer",
          property: "footerImage",
          placeholder: "URL ảnh",
          col: "is-4"
        },
        {
          type: "image",
          label: "Ảnh vòng quay",
          property: "wheelImage",
          placeholder: "URL ảnh",
          col: "is-4"
        },
        {
          type: "image",
          label: "Ảnh pin",
          property: "pinImage",
          placeholder: "URL ảnh",
          col: "is-4"
        },
        {
          col: "is-4"
        },
        {
          type: "text",
          label: "Màu nút",
          property: "buttonColor",
          col: "is-4",
          placeholder: "#FFF"
        },
        {
          type: "text",
          label: "Tên nút",
          property: "btnTitle",
          col: "is-4",
          placeholder: "#FFF"
        },
        {
          type: "text",
          inputType: "number",
          label: "Tỉ lệ thắng",
          property: "successRatio",
          placeholder: "Nhập tỉ lệ",
          col: "is-4",
          constraints: { min: 0, max: 100 }
        }
      ];
      this.fields.forEach(field => {
        field.current = this.campaign[field.property];
      });
    },
    addGift() {
      this.campaign = {
        ...this.campaign,
        gifts: [
          ...this.campaign.gifts,
          { name: "", code: "", image: "", amount: null, used: 0, type: "GIFT" }
        ]
      };
    },
    deleteGift(index) {
      this.campaign.gifts.splice(index, 1);
      this.campaign = { ...this.campaign };
    },
    moveLeft(index) {
      if (index == 0) return;
      let gifts = this.campaign.gifts;
      let temp = gifts[index];
      gifts[index] = gifts[index - 1];
      gifts[index - 1] = temp;
      this.campaign = { ...this.campaign, gifts };
    },
    moveRight(index) {
      let gifts = this.campaign.gifts;
      if (index == gifts.length - 1) return;
      let temp = gifts[index];
      gifts[index] = gifts[index + 1];
      gifts[index + 1] = temp;
      this.campaign = { ...this.campaign, gifts };
    },
    copyItem(index) {
      let gifts = this.campaign.gifts;
      let gift = { ...gifts[index] };
      gifts.splice(index, 0, gift);
      this.campaign = { ...this.campaign, gifts };
    },
    async saveCampaign() {
      try {
        if (this.campaign.spinPoint < 0) {
          this.$buefy.toast.open({
            message: "Lưu thất bại: Điểm vòng quay phải lớn hơn 0!",
            type: "is-danger"
          });
          return;
        }
        if (isBefore(this.campaign.endDate, this.campaign.startDate)) {
          this.$buefy.toast.open({
            message: "Lưu thất bại: Ngày kết thúc phải sau ngày bắt đầu!",
            type: "is-danger"
          });
          return;
        }
        this.saving = true;
        await this.$store.dispatch("campaign/update", {
          id: this.campaign._id,
          data: this.campaign
        });
        this.$buefy.toast.open({
          message: "Lưu thay đổi thành công",
          type: "is-success"
        });
      } catch (err) {
        this.$store.dispatch("error/handleError", err, "Lưu thay đổi thất bại");
      } finally {
        this.saving = false;
      }
    }
  }
});
